export enum EVerticalNames {
  OPOS = 'OPOS',
  UNI = 'UNI',
  WKC = 'WKC',
  FP = 'FP'
}

export enum ESubVerticalUNI {
  PLUS_25 = 'PLUS_25',
  PLUS_45 = 'PLUS_45',
  FIRST_YEAR_HIGH_SCHOOL = 'FIRST_YEAR_HIGH_SCHOOL',
  PCE = 'PCE',
  PORTUGAL = 'PORTUGAL',
  SELE = 'SELE'
}

export enum ESubVerticalFP {
  IT = 'IT',
  REVENUE = 'REVENUE',
  HEALTH_FP = 'HEALTH_FP',
  WORKCAMP = 'WORKCAMP'
}

export enum ESubVerticalOPOS {
  SECURITY_FORCES = 'SECURITY_FORCES',
  HEALTH = 'HEALTH',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  EDUCATION = 'EDUCATION'
}

export enum ESharedSubVerticalNames {
  DEMO = 'DEMO',
  INTERNAL = 'INTERNAL',
  NO_SUBVERTICAL = 'NO_SUBVERTICAL'
}

export type ESubVerticalNames = ESubVerticalUNI | ESubVerticalFP | ESubVerticalOPOS | ESharedSubVerticalNames;

export const ALL_SUBVERTICALS_ENUM = {
  ...ESubVerticalUNI,
  ...ESubVerticalFP,
  ...ESubVerticalOPOS,
  ...ESharedSubVerticalNames,
} as const;

export const ALL_SUBVERTICALS = [
  ...Object.values(ESubVerticalUNI),
  ...Object.values(ESubVerticalFP),
  ...Object.values(ESubVerticalOPOS),
  ...Object.values(ESharedSubVerticalNames),
];

export const ALL_VERTICALS = Object.values(EVerticalNames);
